import { render } from "./DocTable.vue?vue&type=template&id=7bc2c954&scoped=true"
import script from "./DocTable.vue?vue&type=script&lang=js"
export * from "./DocTable.vue?vue&type=script&lang=js"

import "./DocTable.vue?vue&type=style&index=0&id=7bc2c954&scoped=true&lang=css"
import "./DocTable.vue?vue&type=style&index=1&id=7bc2c954&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc2c954"]])

export default __exports__